module.exports = __webpack_public_path__ + "media/images/modify_invitation_resend-9b97a6b3.svg";